const HtmlBodyWrapper = ({children, backgroundBody}) => {
    const styles = {
        margin: 0,
        padding: 0,
        WebkitTextSizeAdjust: '100%',
        backgroundColor: backgroundBody
    }

    return (
        <body style={styles}>
            {children}
        </body>
    )
}

export default HtmlBodyWrapper

